import { NavBar, Form, Button, Input, DatePicker, Selector, Toast } from 'antd-mobile'
import React, { useCallback, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../index.css';
import moment from "moment";
import { gameYearApi } from '../../features/game-year/api/gameYearApi';

export default function GameYearCreate() {

    const [buttomLoading, setButtomLoading] = useState(false)

    const navigate = useNavigate()

    const createGamefunc = (values) => {

        const matchTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');

        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        setButtomLoading(true)
        gameYearApi.save({
            gameTime: matchTime,
            gameAddress: values.gameAddress,
            teamType: 2,
            gameName: values.gameName,
            lat: "30.64728",
            lng: "104.0774",
            dinnerLat: "30.64728",
            dinnerLng: "104.0774",
            dinnerAddress: values.dinnerAddress
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '创建成功！',
                        icon: 'success',
                        afterClose: () => {
                            window.history.back()
                        },
                    })
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail',
                        afterClose: () => {
                            navigate('/home')
                        },
                    })
                }
            })
            .catch(function () {
                Toast.show({
                    content: '创建失败,请重试!',
                    icon: 'fail'
                })
            })
            .finally(() => {
                setButtomLoading(false)
            });

    }

    const minDate = new Date()

    const datePickerRef = useRef();

    const handleDatePickerClick = () => {
        datePickerRef.current?.open();
    };

    const [form] = Form.useForm();

    return (
        <div className="game-year-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                创建年会活动
            </NavBar>
            <div style={{ padding: '16px' }}>
                <Form
                    form={form}
                    name='form'
                    layout='vertical'
                    onFinish={(values) => createGamefunc(values)}
                    initialValues={{
                        gameAddress: "四川大学华西校区东区-足球场",
                        dinnerAddress: ""
                    }}
                    footer={
                        <Button
                            block
                            type='submit'
                            size='large'
                            className="create-activity-btn"
                            style={{ marginTop: '20px' }}
                            loading={buttomLoading}
                        >
                            发布年会活动
                        </Button>
                    }
                >
                    <Form.Header>活动基本信息</Form.Header>
                    <Form.Item name='gameName' label='活动名称' rules={[{ required: true, message: '请输入活动名称' }]}>
                        <Input placeholder='例：科朋2025春节活动' />
                    </Form.Item>

                    <Form.Item
                        name='startTime'
                        label='活动日期'
                        trigger='onConfirm'
                        onClick={handleDatePickerClick}
                        rules={[{ required: true, message: '请选择活动日期' }]}
                    >
                        <DatePicker
                            min={minDate}
                            ref={datePickerRef}
                            precision='minute'
                            title='选择活动时间'
                            mode="date"
                            className="premium-date-picker"
                            renderLabel={useCallback((type, data) => {
                                switch (type) {
                                    case 'year': return data + '年';
                                    case 'month': return data + '月';
                                    case 'day': return data + '日';
                                    case 'hour': return data + '时';
                                    case 'minute': return data + '分';
                                    default: return data;
                                }
                            }, [])}
                            filter={{
                                minute: (val) => val % 5 === 0,
                            }}
                        >
                            {(value) =>
                                value ? (
                                    <div style={{ color: '#1D2129', fontWeight: '500' }}>
                                        {moment(value).format('YYYY年MM月DD日 HH:mm')}
                                    </div>
                                ) : (
                                    <span style={{ color: '#86909C' }}>请选择日期</span>
                                )
                            }
                        </DatePicker>
                    </Form.Item>

                    <Form.Header>场地信息</Form.Header>
                    <Form.Item
                        name='gameAddress'
                        label='活动场地'
                        rules={[{ required: true, message: '请输入或选择活动场地' }]}
                    >
                        <Input placeholder='请输入活动场地名称' />
                    </Form.Item>

                    <Form.Item label='快速选择场地' help='点击下方常用场地快速填充'>
                        <Selector
                            columns={2}
                            options={[
                                { label: '华西东区足球场', value: '四川大学华西校区东区-足球场' },
                                { label: '三分足球场', value: '高新区三分足球场' },
                            ]}
                            onChange={(arr) => {
                                if (arr.length) {
                                    form.setFieldsValue({ gameAddress: arr[0] });
                                }
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name='dinnerAddress'
                        label='晚宴地址'
                    >
                        <Input placeholder='请输入晚宴酒店或餐厅名称' />
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
